import React, { useEffect } from 'react';
import { List, Skeleton } from 'antd';
import TestPOItem from './item';
import { useFormikContext } from 'formik';
import classes from './POItem.module.scss';
import cn from 'classnames';

type Props = {
  poItems: any[];
  className?: string;
  hideTemplate?: boolean;
};

const POItems: React.FC<Props> = ({ poItems, className, hideTemplate }) => {
  const { setFieldValue }: any = useFormikContext();
  const itemRefs = React.useRef(new Map());
  const [poItemVisibility, setPOItemVisibility] = React.useState(new Set());
  const timeoutIds = React.useRef(new Map());

  const handlePOItemVisible = (itemId) => {
    setPOItemVisibility((prev) => {
      const newVisibleItems = new Set(prev);
      if (!newVisibleItems.has(itemId)) {
        newVisibleItems.add(itemId);
      }
      return newVisibleItems;
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const itemId = entry.target.getAttribute('data-id');
            const timeoutId = setTimeout(() => {
              handlePOItemVisible(+itemId);
              observer.unobserve(entry.target);
            }, 50);
            timeoutIds.current.set(itemId, timeoutId);
            // onLoadInitialData(itemId);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    itemRefs.current.forEach((ref) => {
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      observer.disconnect();
      timeoutIds.current.forEach((timeoutId) => clearTimeout(timeoutId));
    };
  }, [poItems]);

  return (
    <List
      className={className}
      dataSource={poItems}
      split={false}
      itemLayout="vertical"
      rowKey={(record: any) => record.id}
      renderItem={(poItem, index) => {
        return (
          <div
            style={!poItemVisibility.has(poItem.id) ? { height: 320 } : {}}
            data-id={poItem.id}
            ref={(node) => {
              itemRefs.current.set(poItem.id, node);
            }}
            className={cn(classes['fade-in'], {
              [classes.visible]: poItemVisibility.has(poItem.id),
              [classes['fade-out']]: !poItemVisibility.has(poItem.id),
              [classes.hidden]: !poItemVisibility.has(poItem.id),
            })}
          >
            {poItemVisibility.has(poItem.id) ? (
              <TestPOItem
                hideTemplate={hideTemplate}
                ordinalNumber={index + 1}
                item={poItem}
                onChange={(updated) => {
                  setFieldValue(`inspectionPOItems[${index}]`, updated);
                }}
              />
            ) : (
              <Skeleton active />
            )}
          </div>
        );
      }}
    />
  );
};

export default POItems;
